import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { commonService } from '../../services/commonService';

export const useGetCountries = params => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.common.countries, params],
    queryFn: () =>
      commonService.countries(params).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
